import PickRecordBuilder from "ags/integration/builders/records/pick-record-builder";
import { AGSSAuthResponseSchema } from "ags/integration/schema/ags-auth-response-schema";
import { AGSPickSchema, AGSSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import BetModel from "slotworks/model/bets/bet-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import builderManager from "slotworks/server/builders/builder-manager";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import AGSRecordUtils from "../ags-record-utils";
import { AGSRecordBuilder } from "./abstract-ags-record-builder";
import AuthRecordBuilder from "./auth-record-builder";
import SpinRecordBuilder from "./spin-record-builder";

export class RecoveryRecordBuilder extends AGSRecordBuilder implements RecordBuilder {

    protected spinRecordBuilderInstance: typeof SpinRecordBuilder = SpinRecordBuilder;

    public filter(request: any, response: any): boolean {
        if (request instanceof AuthRequestPayload) {
            const authResponse = JSON.parse(response.data) as AGSSAuthResponseSchema;
            const publicState = authResponse.publicState;

            return publicState.recoveredGame !== undefined;
        }
        return false;
    }

    public build(gameplay: Gameplay, request: any, response: any): Record[] {
        AuthRecordBuilder.build(gameplay, request, response);

        gameplay.isRecovered = true;
        gameplay.startBalance = gameplay.balance;

        const authResponse = JSON.parse(response.data) as AGSSAuthResponseSchema;
        const publicState = authResponse.publicState;
        const recoveredState = publicState.recoveredGame;
        BetModel.freeBet = this.isFreeBet(authResponse.config);

        const options = new ControlOptions();
        options.creditsPerLine.currentValue = recoveredState.betAmount;
        options.creditSizes.currentValue = recoveredState.denom;

        if (BetModel.freeBet) {
            options.creditsPerLine.currentValue = authResponse.config.forcedStake;
            options.creditSizes.currentValue = authResponse.config.forcedDenomination;
        }
        BetModel.updateFromOptions(options);

        const spinData = recoveredState.spin;

        const spinRecord = this.spinRecordBuilderInstance.buildRecord(spinData, false, spinData);
        spinRecord.results = spinRecord.results.concat(builderManager.buildResult(spinRecord, publicState));

        spinRecord.grid = AGSRecordUtils.convertreelsToSlotworksGrid(spinData.reels);

        const records = this.processChildFeatures(spinData.childFeature, spinRecord, spinData, spinData.complete);

        records.unshift(spinRecord);

        const dummyWins = this.getDummyWins(records, spinData);
        records.splice(records.length - spinData.childFeature.length, 0, ...dummyWins);

        return records;
    }

    // Correct for missing records with dummy records
    // const totalFreespinWin =
    // sumWinsFreeSpins: 5820
    protected getDummyWins(records: Record[], spinData: AGSSpinSchema) {
        const dummyWins: Record[] = [];

        let totalTrackedFreespinCashWins = 0;
        let totalTrackedFreespinWins = 0;
        let totalTrackedFreespins = 0;
        records.forEach((record) => {
            if (record instanceof SpinRecord || record instanceof FreespinRecord) {
                totalTrackedFreespinWins += record.getFreespinsWon();
            }
            if (record instanceof FreespinRecord) {
                totalTrackedFreespins++;
                totalTrackedFreespinCashWins += record.cashWon;
            }
        });

        const untrackedFreespinCashWins = spinData.sumWinsFreeSpins - totalTrackedFreespinCashWins;
        const untrackedFreeSpinWins = spinData.totalFreeSpins - totalTrackedFreespinWins;
        const untrackedFreeSpins = (spinData.totalFreeSpins - spinData.freeSpinsLeft) - totalTrackedFreespins;

        for (let dummyId = 0; dummyId < untrackedFreeSpins; dummyId++) {
            const dummyWin = new FreespinRecord();

            if (dummyId === 0) {
                const dummyFreespinWin = new FreespinWinResult();
                dummyFreespinWin.freespinsWon = untrackedFreeSpinWins;
                dummyWin.results = [dummyFreespinWin];
                dummyWin.cashWon = untrackedFreespinCashWins;
            }

            dummyWins.push(dummyWin);
        }

        return dummyWins;
    }

    protected processChildFeatures(childFeatures: AGSSpinSchema[] | AGSPickSchema[], parentRecord: SpinRecord, rootSpin: AGSSpinSchema, parentComplete?: boolean): Record[] {
        const records = [];

        if (childFeatures && childFeatures.length > 0) {
            for (const childFeature of childFeatures) {
                if (childFeature.type === "freeSpin") {

                    const freespin = childFeature as AGSSpinSchema;
                    const freespinRecord = this.spinRecordBuilderInstance.buildRecord(freespin, true, rootSpin);

                    freespinRecord.hasChildren = false;
                    records.push(freespinRecord);

                    if (freespin.childFeature && freespin.childFeature.length > 0) {
                        freespinRecord.hasChildren = true;
                        records.push(...this.processChildFeatures(freespin.childFeature, freespinRecord, rootSpin));
                    }
                } else if (childFeature.type === "pick") {
                    const record = PickRecordBuilder.buildRecord(childFeature as AGSPickSchema, parentComplete);

                    if (record.complete) {
                        parentRecord.setBonusPlayed("pick");
                    }

                    records.push(record);
                }
            }
        }

        return records;
    }
}

export default new RecoveryRecordBuilder();
